module.exports = __webpack_public_path__ + "static/media/modal_title.20ee73e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/modal_title.png
// module id = 1500
// module chunks = 0